<template>
  <b-container fluid class="bv-example-row">
        <!-- <img style="height: 50px;margin: 40px 0px 80px 0px;" src="/img/logo.svg"> -->
        <img class="logo_recuperar_contraseña" src="/img/logo.png">
        <!-- <b-img class="circulo"  :src="circulo"></b-img>   -->
        <div class=" recuperarcx ">
          
          <button @click="$router.push('/login')" class="btn  form-control   volverr " >
            <b-icon icon="arrow-left" class="fekcga"></b-icon>
            <!-- <img class="fekcga" src="/img/regresar.svg" alt="" srcset="">  -->
            <span class="poppins-semi-bold-blue-violet-14px">Volver</span></button>
          <h3 class=" titll mb-5rc text-center poppins-semi-bold-mine-shaft-20px" > {{ recuperarContrasea }}</h3>

          <p class="  poppins-normal-tuatara-14px" style=" line-height: 21px; letter-spacing: 0; margin-bottom: 8%;"> Si ha olvidado su contraseña no se  <br>preocupe.
            Ingrese su Correo Electrónico <br>y le enviaremos instrucciones de cómo <br>cambiarla. </p>
          <label for="correo" class="form-label fw-bold text-start poppins-semi-bold-tuatara-14px">Correo electrónico</label>
          <input required @input="validateEmail()" id="correo" class="form-control campo tm vm" @focus="placeholderr()" @blur="placeholderre()"  :placeholder="placeholder" type="email" v-model="email"/>

          <div class=" text-end poppins-normal-alizarin-crimson-12px rojotex" role="alert" v-if="this.msg" >{{ msg }}</div>
          <button @click="Sendemail()" class="btn form-control  btnenviar"  ><span class="poppins-semi-bold-white-14px"><div v-if="this.load == false">{{ enviar }}</div></span><div v-if="this.load == true"><b-spinner small></b-spinner><span class="sr-only ingresar poppins-semi-bold-white-14px">Cargando...</span></div></button>
          <div v-if="this.messgg == true" class="ingrese-una-contraseas poppins-normal-white-12px">{{ datos }}</div>
        </div>
  </b-container >
</template>


<script>
import { RepositoryFactory } from "../repositories/RepositoryFactory";
import Cielum from "../components/Cielum.vue";

const recoverpass = RepositoryFactory.get("recoverpass");

export default {
  name: "recuperarcontrasena",

  components: {
    Cielum,
  },

  props: [
    "overlapGroup13",
    "boxProps",
    "cielumProps",
    "circulo",
    "title",
    "overlapGroup2",
    "recuperarContrasea",
    "siHaOlvidadoSuCo",
    "ingreseSuCorreoEl",
    "correoElectrnico",
    "ejemploCorreoCom",
    "enviar",
    "grupo78Props",
    "prmCielum1",
    "trazado474",
    "portalClnicoCielum",
    "inicioDeSesin1",
    "prmCielum3",
    "prmCielum2",
    "grupo78Props",
    "grupo78Props2",
    "trazado196",
    "trazado197",
    "trazado198",
    "trazado199",
    "trazado90",
    "trazado91",
    "trazado92",
    "trazado93",
    "overlapGroup13",
    "lnea3",
    "datos",
  ],

  data() {
      return {
        load:false,
          email: null,
          msg: null,
          messgg: false,
          placeholder :"example@hotmail.com",
      }
  },

  methods: {
    placeholderr(){
            this.placeholder = "";
        },
        placeholderre(){
            this.placeholder = "example@hotmail.com";
        },
  async  Sendemail() {
    if(this.email == '' ||this.email == null){
      this.msg= 'Por favor ingrese un correo electrónico';
    }else{
      var emailReg = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
      var emailValido = emailReg.test(this.email);
      if (emailValido == true) {
        this.load= true;
        const response = await recoverpass.recoverPasswordEmail({
                  "email": this.email
              }).then((respuesta) => {

               this.load= true;
                 this.$router.push({ name: 'mensajeEnviado', params: { email: this.email,} });
              }).catch((error) => {
            this.load= true;
                  if(error.response.data.error.code=="UI401"){
                       this.messgg = true
                       this.load= false;
                   }  
                if(error.message.includes("500")){
                    return  this.$router.push("/error500");
                }
                if(error.message.includes("400")){
                    alert("error "+ error.message.toString());
                }
                if(error.status == 401){
                  this.messgg= true;
                }
              if (error.status == 404 || error.status == 409 ) {
                  
                   this.isPopup = false;
              }   
          });
      }else{
        this.msg = 'Ingrese un correo electrónico válido';
      }
    }
      
  },


    validateEmail() {
      var emailReg = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
      var emailValido = emailReg.test(this.email);
      if (emailValido == true) {

      }
      else{
        // this.msg = 'Ingrese un correo electrónico válido';
      }
    //   if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.msg)) {
    //     this.msg= 'Por favor verifique su correo electrónico';
    // } else {
    //     this.msg= 'Por favor ingrese un correo electrónico';
    // }
  },
    


  }
};
</script>

<style>
.bv-example-row{
   background-color: var(--blue-violet);
     height: 100vh;
       text-align: center;
}
.rojotex{
  position: absolute;
    bottom: 18%;
    right: 10%;
}
.vm{
  margin-bottom: 9%;
}
.titll{
  margin-top: 18%;
}
.fekcga{
  margin-right: 2%;
}
.volverr{
  background-color: var(--link-water) !important;
  border-radius: 10px !important;
  height: 52px;
   border-color: var(--link-water) !important; 
  color: var(--blue-violet) !important
}
.btnenviar{
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 52px;
   border-color: var(--blue-violet) !important; 
  color: var(--white) !important
}
.btnenviar:hover{
  background-color: var(--hover) !important;
}
.recuperarcx{
  /* width: 360px !important;
  padding: 2% 2%!important;
    background-color: var(--zircon) ;
    border-radius: 10px !important;
    margin-top:4%;
    border-color:transparent !important ;
    z-index: 1;
    border-color:transparent !important ; */
     background-color: var(--zircon);
  border-radius: 10px !important;
  padding: 0.8rem;
  max-width: 20rem;
  margin: auto;
  z-index: 1;
    border-color:transparent;
}
.body{
  overflow-x:hidden;
  overflow-y:hidden;
}

.custom-size-14-recuperar-contrasena-1 {
  align-items: flex-start;
  background-color: var(--blue-violet);
  display: flex;
  height: 784px;
  overflow: hidden;
  padding: 0 464px;
  width: 1920px;
}

html{
  overflow: hidden !important;
}

.overlap-group2-14 {
  align-items: flex-end;
  background-color: var(--zircon);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  min-height: 526px;
  padding: 40px 38px;
  position: relative;
  width: 360px;
}
.si-ha-olvidado-su-co-4 {
  letter-spacing: 0;
  line-height: 14px;
  margin-top: 38px;
  min-height: 85px;
  text-align: center;
  width: 282px;
}

.ingrese-un-correo-electrnico-vlido-1 {
  letter-spacing: 0;
  line-height: 12px;
  margin-top: 2px;
  min-height: 19px;
  text-align: right;
  width: 282px;
}
@media (max-width: 669px) {
.logo_recuperar_contraseña {
    margin: 6% 0 3% !important;
  width: 20% !important;
}
}



@media screen and (max-width:991px){
  .grupo-container-13 {
    align-items: center;
    background-position: 50% 50%;
    background-size: cover;
    border-radius: 496px;
    display: flex;
    flex-direction: column;
    /* gap: 93px; */
    /* margin-top: -104px; */
    /* min-height: 992px; */
    /* position: relative; */
    /* width: 100%;
    padding: 0px 50% 0px 50%;
    justify-content: center; */
  }
  .p-5{
    width: 400px;
    padding: 10px !important;
  }
  
}
.btn{
  /*  height: 50px !important;*/
  }

  /* .form-control:focus {
    color: #212529;
    background-color: #fff;
    border-color: #E61717 !important;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgb(253 13 13 / 25%) !important;
    border-width: 1px !important;
    border-radius: 5px !important;
  } */
  .logo_recuperar_contraseña{
     margin: 2% 0 2%;
  width: 20%;
    }



.custom-size-14-recuperar-contrasena {
  align-items: flex-start;
  background-color: var(--blue-violet);
  display: flex;
  height: 784px;
  overflow: hidden;
  padding: 0 272px;
  width: 1536px;
}

.grupo-container {
  align-items: center;
  background-position: 50% 50%;
  background-size: cover;
  border-radius: 496px;
  display: flex;
  flex-direction: column;
  gap: 93px;
  margin-top: -61px;
  min-height: 992px;
  padding: 143px 0;
  position: relative;
  width: 992px;
}

.grupo-9244 {
  align-items: center;
  background-color: #f5f6ff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  min-height: 500px;
  padding: 40px 38px;
  width: 360px;
}

.grupo-8954 {
  align-items: center;
  background-color: var(--link-water);
  border-radius: 10px;
  display: flex;
  height: 50px;
  justify-content: flex-end;
  min-width: 280px;
  padding: 0 102.8px;
}

.grupo-9366 {
  display: flex;
  gap: 10px;
  height: 14px;
  width: 73px;
}

.trazado-6180 {
  align-self: flex-end;
  height: 13px;
  margin-bottom: -5.6px;
  margin-left: 0;
  object-fit: cover;
  width: 15.18px;
}

.volver {
  color: var(--blue-violet);
  flex: 1;
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-m);
  font-weight: 600;
  height: 22px;
  letter-spacing: 0;
  line-height: 14px;
  margin-right: -2px;
  text-align: center;
  white-space: nowrap;
  width: 48px;
}

.recuperar-contrasea {
  align-self: flex-end;
  color: #333333;
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-l);
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: 40px;
  min-height: 30px;
  text-align: center;
  width: 282px;
}

.si-ha-olvidado-su-co {
  align-self: flex-end;
  color: var(--tuatara);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-m);
  font-weight: 400;
  letter-spacing: 0;
  margin-top: 20px;
  min-height: 85px;
  text-align: center;
  width: 282px;
}

.grupo-8969 {
  display: flex;
  flex-direction: column;
  height: 75px;
  justify-content: space-between;
  margin-top: 20px;
  width: 280px;
}

.grupo-9242 {
  display: flex;
  flex: 1;
  height: 20px;
  max-height: 20px;
}

.correo-electrnico {
  color: var(--tuatara);
  flex: 1;
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-m);
  font-weight: 600;
  height: 22px;
  letter-spacing: 0;
  line-height: 14px;
  margin-right: -2px;
}

.grupo-8968 {
  align-items: flex-end;
  background-color: var(--white);
  border: 1px solid;
  border-color: var(--link-water);
  border-radius: 10px;
  display: flex;
  flex: 1;
  height: 50px;
  max-height: 50px;
  min-width: 100%;
  padding: 14px 19px;
}

.lorem-ipsum {
  color: #b3b3b3;
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-m);
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
  min-height: 22px;
  width: 202px;
}

.grupo-8944 {
  align-items: flex-end;
  background-color: var(--blue-violet);
  border-radius: 10px;
  display: flex;
  height: 50px;
  justify-content: flex-end;
  margin-top: 40px;
  min-width: 280px;
  padding: 13px 18px;
}

.enviar {
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-m);
  font-weight: 600;
  letter-spacing: 0;
  line-height: 14px;
  min-height: 22px;
  text-align: center;
  width: 242px;
  padding: 7px 18px;
}

.logoq{
        margin-top:8%;
}
.centrar_logo{
  width: 72%;
  text-align: center;
  margin-top: 6%;
  margin-left: 13%;
}
body{
  overflow-y: hidden;
}
    @media (max-width: 1922px) {
 
    .logoq {
        margin-left: 8%;
    }
    }
    @media (max-width: 1540px) {

    .logoq {
        margin-left: 0%;
    }
    .mb-5rc {
    margin-bottom: 1rem !important;
}
    }
    @media (max-width: 1370px) {
  .titll{
  margin-top: 6%;
}
.mb-5rc {
    margin-bottom: 6% !important;
}
/* .recuperarcx {
    width: 320px !important;
    margin-top: 1%;
} */
/* .logo_recuperar_contraseña {
  width: 13%;
  height: 52px ;
    margin-bottom: 0%;
    margin-top: 2%;
} */
}
    @media (max-width: 1280px) {
      .mb-5rc {
    margin-bottom: 3% !important;
}
      .titll {
    margin-top: 4%;
}
      /* .recuperarcx {
        padding: 1.5%;
      } */
 
    .logoq {
        margin-top: 6%;
        width: 32%;
        margin-left: 13%;
    }

    .custom-size-14-recuperar-contrasena {
        margin-bottom: 7%;
    }
    .campo {
        margin-top: 4%;
        margin-bottom: 6%;
        height: 45px;
    }
    /* .input-group-text {
        margin-top: 25%;
        margin-bottom: 10%;
        height: 61%;
        } */
        /* .recuperarcx {
    width: 304px !important;
    margin-top: 1% !important;
} */
/* .logo_recuperar_contraseña {
    width: 14%;
    margin: 16px 0px 6px 0px;
} */

      
    .grupo-container {
        margin-top: 9%;
        margin-left: -13%;
        margin-right: -13%;
    }
    .ingrese-un-correo-electrnico {
        margin-top: -4%;
    }
    }
    @media (max-width: 1100px) {
  
    .logoq {
        margin-top: 3%;
        width: 39%;
        margin-left: 22%;
    }
  
    .custom-size-14-recuperar-contrasena {
        margin-bottom: 5%;
    }
    .grupo-container {
        margin-top: 7%;
        margin-left: -12%;
        margin-right: -12%;
    }
    
    }
    .body{
      background-color: #5460b5;
      background-image: url(/img/transparencia.png);
      background-position: center;
      background-repeat-x: no-repeat;
    }

  .form-control{
    display: block;
    width: 100%;
    padding: -0.750rem 0.75rem;
    /* font-size: 1rem; */
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 0.375rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  }

</style>
